import { render, staticRenderFns } from "./PageMealPlan.vue?vue&type=template&id=294b9635"
import script from "./PageMealPlan.vue?vue&type=script&lang=js"
export * from "./PageMealPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports